import { MapSearchBlockContent } from '../../../../interfaces/map.interface';
import { SearchBlockContentStrategy } from './search-block-content.strategy';

export class DefaultSearchBlockContentStrategy extends SearchBlockContentStrategy {
  public constructor(mapSearchBlockContent: MapSearchBlockContent) {
    super(mapSearchBlockContent);
  }

  public emitSearchFormContent(): void {
    this.updateFieldsVisibility({});
  }
}
